import axios from 'axios'
import config from '@config'
import { Message } from 'element-ui'
import utils from '@/utils'

//默认配置信息
const axiosConfig = {
  timeout: 2 * 60 * 1000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    //配置请求版本
    version: config.version,
  },
}

const baseURL = ''

const name = 'Originp'

const newAxios = axios.create(utils.mergeDeep(axiosConfig, config, baseURL))

//通用请求
function requestInterceptors(config) {
  const { headers } = config
  const timestamp = +new Date()
  //参数配置处理
  ;[`data`, `params`].forEach((key) => {
    //深拷贝处理
    config[key] = (() => {
      if (!config[key]) {
        return {}
      } else {
        return utils.deepClone(config[key]) || {}
      }
    })()
  })
  const currentMethod = config.method.toLocaleLowerCase()
  if (currentMethod === `get`) {
  } else {
  }
  if (config.formData) {
    const searchParams = new URLSearchParams(config.data)
    config.data = searchParams.toString()
  }
  return config
}

//通用请求错误
function requestInterceptorsErr(err) {
  const { config } = err
  return Promise.reject(err)
}

//下载流
function downStream(response) {
  const { pdf } = response.config
  const type = pdf ? 'application/pdf' : 'application/octet-stream'
  const contentDisposition = response.headers['content-disposition']
  const filename = contentDisposition && contentDisposition.split('filename=')[1].replace(/"/g, '')
  const blob = new Blob([response.data], { type })
  const blobURL = window.URL.createObjectURL(blob)
  const tempLink = document.createElement('a')
  tempLink.style.display = 'none'
  tempLink.href = blobURL
  tempLink.setAttribute('download', decodeURI(filename) || 'unknown-file')
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
  window.URL.revokeObjectURL(blobURL)
}

//通用响应
function responseInterceptors(res) {
  const { config } = res
  const { data } = res
  //success 在来平台上作为提示信息使用
  const { code, status, success, msg, desc, resCode } = data

  // 字符串JSON处理
  if (typeof data.data === `string`) {
    data.data = (() => {
      const { data: _data } = data
      try {
        return JSON.parse(_data)
      } catch (e) {
        return _data
      }
    })()
  }

  //配置是否显示loading
  //存在pend处理，解锁pend处理
  config.pendKey &&
    requestPend.load({
      key: config.pendKey,
    })
  //下载流
  if (res.headers['content-disposition']) {
    downStream(res)
  } else {
    //两套框架业务
    if (code === 0 || status === true || resCode == 0 || code == 200) {
      if (config.message !== false && (success || msg || desc) && msg !== 'SUCCESS') {
        Message({
          message: success || msg || desc,
          type: 'success',
          duration: config.toastDelayTime || 2000,
        })
      }
      //返回所有值
      if (config.current) return data
      return data.data
    }
    return Promise.reject(res)
  }
}

//通用响应错误
function responseInterceptorsErr(err) {
  const { response, config: axiosConfig } = err
  if (response) {
    const code = response.status
    if (response.data && response.data.code === undefined) {
      if (typeof response.data === `string`) {
        response.data = {
          msg: response.data,
          code,
        }
      } else {
        response.data.code = code
      }
    }
    if (code >= 500 && code < 600) {
      Message.error(`找不到服务:${code}`)
    } else if (code === 404) {
      Message.error('找不到请求数据:404')
    } else if (code === 401) {
    }
  } else if (/timeout/.test(err.message)) {
    Message.error('请求超时')
  } else if (/Network\sError/.test(err.message)) {
    Message.error('网络已断开，请检查网络')
  }
  return Promise.reject(err)
}

newAxios.interceptors.request.use(requestInterceptors, requestInterceptorsErr)

newAxios.interceptors.response.use(responseInterceptors, responseInterceptorsErr)

export function expandAxios(opts = {}) {
  const { Vue } = opts
  //设置多个实例化接口的Vue原型方法
  Vue.prototype[`$post${name}`] = newAxios.post
  //get请求
  Vue.prototype[`$get${name}`] = function (url, params, config = {}) {
    return newAxios.get(url, {
      params,
      //配置信息
      ...config,
    })
  }
}
